<script setup>
import { defineAsyncComponent, computed } from "vue";

const WorkflowTable = defineAsyncComponent(() =>
  import("@/features/workflow-builder/WorkflowTable.vue")
);

const props = defineProps({
  form: { type: Object, required: true },
});

const templateUuid = computed(() => props.form?.uuid || null);

defineExpose({
  validate: async () => true,
});
</script>

<template>
  <div class="w-full h-full">
    <WorkflowTable v-if="templateUuid" :template-uuid="templateUuid" />
    <div
      v-else
      class="flex items-center justify-center h-full text-[13px] text-muted-foreground"
    >
      —
    </div>
  </div>
</template>
